import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { getTimezoneTextById } from '../../common/utils/date.helpers';
import { IconNames } from '../../common/constants/icon-names';

@Component({
  selector: 'ui-hub-timezone-message',
  templateUrl: './hub-timezone-message.component.html',
  styleUrls: ['./hub-timezone-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HubTimezoneMessageComponent {
  @Input() timezoneId: string;

  get timezoneText(): string {
    return getTimezoneTextById(this.timezoneId);
  }

  iconNames = IconNames;
}
